import { createFileRoute } from "@tanstack/react-router";
import { TradeCityHubPage } from "@/components/hubs/TradeCityHubPage";
import { seoHead } from "@/components/hubs/HubPages";
import { TRADE_CITY_HUBS } from "@/lib/tradeCityHubs";

const HUB = TRADE_CITY_HUBS.find((h) => h.path === "/colorado-springs-hvac-marketing")!;

export const Route = createFileRoute("/colorado-springs-hvac-marketing")({
  head: () => seoHead(HUB.path, HUB.metaTitle, HUB.metaDescription),
  component: () => <TradeCityHubPage hub={HUB} />,
});
